import { render, staticRenderFns } from "./quran_view.vue?vue&type=template&id=fcc59aec&scoped=true"
import script from "./quran_view.vue?vue&type=script&lang=js"
export * from "./quran_view.vue?vue&type=script&lang=js"
import style0 from "./quran_view.vue?vue&type=style&index=0&id=fcc59aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc59aec",
  null
  
)

export default component.exports